// extracted by mini-css-extract-plugin
export default {"form":"styles_form__ShIdb","input":"styles_input__In1ZU","select":"styles_select__fN49G","submitButton":"styles_submitButton__QwSG8"};